import { FlexibleContent, HeroSlider } from '@/templates';
import { getBaseLayout } from '@/layouts/BaseLayout';

import getInitialProps from '@/lib/graphql/api/getInitialProps';
import {
  FlexibleContentBlocks,
  pagePropsPartial,
  sliderHero,
} from '@/lib/graphql/partials';
import { PageQuery } from '@/lib/graphql/querys';

import type { NextPageWithLayout } from './_app';

// TODO: Añadir tipos
const ComoRegalar: NextPageWithLayout = ({
  page: { hero, flexibleContent },
}: any) => (
  <>
    <HeroSlider hero={hero} />

    <FlexibleContent type="Page" flexible={flexibleContent.flexible} />
  </>
);

export async function getStaticProps() {
  const h = `
    page(id: $slug, idType: URI) {
      flexibleContent: ${FlexibleContentBlocks('Page')}
      hero: ${sliderHero('Page')}
    }
  `;

  const Query = PageQuery(pagePropsPartial, h);

  return await getInitialProps(Query, {
    slug: 'disfruta-de-la-cerveza-a-domicilio',
  });
}

ComoRegalar.getLayout = getBaseLayout;

export default ComoRegalar;
